module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0165.jpg?v=19bf48d5";